"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackPageView = trackPageView;
exports.trackEditorInteraction = trackEditorInteraction;
exports.trackEditorError = trackEditorError;
exports.trackDashboardInteraction = trackDashboardInteraction;
exports.trackEmailInteraction = trackEmailInteraction;
exports.tracker = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _events = _interopRequireDefault(require("lead-flows-ui/events.yaml"));

var _usageTracker = require("usage-tracker");

var _enviro = _interopRequireDefault(require("enviro"));

var UsageTracker = (0, _usageTracker.createTracker)({
  events: _events.default,
  properties: {
    namespace: 'lead-flows'
  },
  lastKnownEventProperties: ['screen', 'subscreen'],
  onError: function onError(err) {
    if (_enviro.default.getShort() === 'qa') {
      console.error(err.message); // eslint-disable-line no-console
    } else {
      window.Raven.captureMessage('usage-tracker-js event error', {
        extra: {
          message: err.message
        }
      });
    }
  }
});
var tracker = UsageTracker;
exports.tracker = tracker;

function trackPageView(properties) {
  tracker.track('pageView', properties);
}

function trackEditorInteraction(action, properties) {
  tracker.track('editorInteraction', Object.assign({}, {
    action: action
  }, properties));
}

function trackEditorError(action) {
  tracker.track('trackError', {
    action: action
  });
}

function trackDashboardInteraction(action, properties) {
  tracker.track('dashboardInteraction', Object.assign({}, {
    action: action
  }, properties));
}

function trackEmailInteraction(data) {
  tracker.track('trackEmailSuspensionInteraction', (0, _extends2.default)({}, data));
}